import {useDocumentContext} from '@/components/document/context';
import Message from '@/components/message';
import {DocumentUIField} from '@/engine/types';
import {FieldProps} from '../../meta-field';

export const MessageField = ({field}: FieldProps<DocumentUIField>) => {
  const {valueResolver, visibilitySet} = useDocumentContext();

  return (
    <Message
      dataTestid={field.id}
      variant={field.layout?.variant || 'primary'}
      size={field.layout?.size || 'base'}
      text={valueResolver(field.label, {visibilitySet})}
    />
  );
};
